import FooterButton from "../footer/footerButton";
import ButtonOnly from "../button/buttonOnly";

import "./hint.css";

export default function Hint({ hintContent, onClose }) {
  return (
    <div id="content" className="hintDiv">
      <div className="boxPop content_box1">
        <div className="box_con  con_box_hint con_pd9 ">
          <div className="missionDiv">
            <div className="missionDi">
              <div className="mission_tit mission_tit4 mt40 "></div>
              <div
                className="mission_txt_b mt16 hint_text "
                dangerouslySetInnerHTML={{ __html: hintContent }}
              />
            </div>
          </div>
          <FooterButton
            ftIdName="box_ft"
            buttonClass="inputBtn02 con_box_hint_btn"
            buttonValue="정답보기 닫기"
            onFinish={onClose}
          />
        </div>
      </div>
    </div>
  );
}
